"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewAdRequestToJSON = exports.ReviewAdRequestFromJSONTyped = exports.ReviewAdRequestFromJSON = exports.instanceOfReviewAdRequest = void 0;
var runtime_1 = require("../runtime");
var AdReviewStatus_1 = require("./AdReviewStatus");
/**
 * Check if a given object implements the ReviewAdRequest interface.
 */
function instanceOfReviewAdRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "reviewStatus" in value;
    return isInstance;
}
exports.instanceOfReviewAdRequest = instanceOfReviewAdRequest;
function ReviewAdRequestFromJSON(json) {
    return ReviewAdRequestFromJSONTyped(json, false);
}
exports.ReviewAdRequestFromJSON = ReviewAdRequestFromJSON;
function ReviewAdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': json['version'],
        'reviewStatus': (0, AdReviewStatus_1.AdReviewStatusFromJSON)(json['review_status']),
        'rejectReason': !(0, runtime_1.exists)(json, 'reject_reason') ? undefined : json['reject_reason'],
    };
}
exports.ReviewAdRequestFromJSONTyped = ReviewAdRequestFromJSONTyped;
function ReviewAdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
        'review_status': (0, AdReviewStatus_1.AdReviewStatusToJSON)(value.reviewStatus),
        'reject_reason': value.rejectReason,
    };
}
exports.ReviewAdRequestToJSON = ReviewAdRequestToJSON;
